import React, { useState } from 'react';
import SarasWrapper from '../../container/SarasWrapper';
import SarasTooltip from '../../notifications/SarasTooltip';
import SarasTrans from '../../notifications/SarasTrans';
import SarasChip from '../../repeater/list/SarasChip';
import * as fn from '../../../helper/uiFunctions';

const FormROChipValue = (props) => {
const {
formObject, translate, action, useVal,
hideIfEmpty, maxValueLength, rowKey, headerKey, format,
customWrapper, wrapperClass, className, yesClass, noClass, tooltip,
icon, onClick, onDelete, // Chip-specific
linkType, // 'tel' | 'mailto' | 'wa' to wrap chip in appropriate link
copyOnClick, // when true, clicking chip copies its text to clipboard
copyFeedback = true, // show transient "Copied" feedback in tooltip
...restProps
} = props;
const [copied, setCopied] = useState(false);

const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

const getValue = () => {
let value = "";
if (useVal) {
value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.val);
} else {
value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);
}

let title = '';

if (format === "#" && fn.compareNumber(value, 0)) value = '';
if (format === "a" && fn.compareNumber(value, 0)) value = '-';
if (format === "hhmm") value = fn.convertMinutesToHHMM(viewData.val);

if (translate) {
  return { node: <SarasTrans value={value} />, raw: value, title: "" };
}

if (maxValueLength && value && value.length > maxValueLength) {
  title = value;
  value = value.substring(0, maxValueLength) + " ...";
}

return { raw: viewData.val, text: value, title };

};

if (viewData && hide === "0") {
const displayValue = getValue();

if (hideIfEmpty && (displayValue.text === "" || displayValue.text === undefined)) {
  return null;
}

let boolClass = "";
if (yesClass || noClass) {
  boolClass = fn.compareNumber(displayValue.raw, 1) ? yesClass : noClass;
}

// Chip data model follows SarasChip’s expected shape
const chipData = {
  key: action?.paramName || "",
  val: translate ? displayValue.node : displayValue.text
};

const chipProps = {
  data: chipData,
  onClick,
  onDelete
};

// Build actionable href based on linkType and display value
let href;
if (linkType && displayValue.text) {
  const raw = String(displayValue.text).replace(/\s+/g, '');
  if (linkType === 'tel') href = `tel:${raw}`;
  else if (linkType === 'mailto') href = `mailto:${raw}`;
  else if (linkType === 'wa') {
    // normalize to digits for wa.me
    const digits = raw.replace(/[^\d+]/g, '');
    const waNum = digits.startsWith('+') ? digits.slice(1) : digits;
    href = `https://wa.me/${waNum}`;
  }
}

// If copy-on-click is enabled, override href behavior to prevent navigation
const handleCopyClick = async (e) => {
  if (!copyOnClick) return;
  e.preventDefault();
  const text = displayValue.text || '';
  try {
    await navigator.clipboard.writeText(text);
    if (copyFeedback) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    }
  } catch (err) {
    // silently fail if clipboard API not available
  }
};

return (
  <SarasWrapper customWrapper={customWrapper} wrapperClass={wrapperClass}>
    <SarasTooltip title={copied ? 'Copied' : (displayValue.title || tooltip || '')}>
      {href && !copyOnClick ? (
        <a href={href} className={`${className} ${boolClass} ${viewData.dataList ? viewData.dataList.colCssClass : ''}`} {...restProps}>
          <SarasChip {...chipProps} icon={icon} />
        </a>
      ) : (
        <span
          className={`${className} ${copyOnClick ? 'uiChipClickable' : ''} ${boolClass} ${viewData.dataList ? viewData.dataList.colCssClass : ''}`}
          onClick={handleCopyClick}
          {...restProps}
          aria-live={copyFeedback ? 'polite' : undefined}
          role={copyFeedback ? 'status' : undefined}
        >
          <SarasChip {...chipProps} icon={icon} />
        </span>
      )}
    </SarasTooltip>
  </SarasWrapper>
);

}

return null;
};

export default FormROChipValue;
